import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CommunityGameRoute extends DiscourseRoute {
  @service communityNavigation;
  @service store;

  queryParams = {
    order: { refreshModel: true },
  };

  async model({ game_key: gameKey, order = "latest" }) {
    const [topicList] = await Promise.all([
      this.store.findFiltered("topicList", {
        filter: "community-navigation/topics",
        params: { section: "game", game: gameKey, order, page: 0 },
      }),
      this.communityNavigation.load(),
    ]);
    const game = this.communityNavigation.games.find(
      (candidate) => candidate.key === gameKey
    );
    return {
      topicList,
      gameKey,
      game,
      order,
      title: game?.name || i18n(`community_navigation.game_names.${gameKey}`),
    };
  }

  titleToken(model) {
    return model?.title;
  }
}
